import { render } from "./ProjectEmployees.vue?vue&type=template&id=2afa0aea"
import script from "./ProjectEmployees.vue?vue&type=script&lang=js"
export * from "./ProjectEmployees.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__